// WishlistContext.js
import { createContext, useContext, useState, useEffect } from "react";
import useAddToWishlist from "../hooks/useAddToWishlist";

const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
  const [wishlist, setWishlist] = useState([]);
  const { addToUserWishlist } = useAddToWishlist();


  // Load wishlist from local storage on initial render
  useEffect(() => {
    const localWishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    setWishlist(localWishlist);
  }, []);

  // Add item to wishlist
  const addToWishlist = (product) => {
    const localWishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    const item = { product, color: null };
    if (!localWishlist.some((i) => i.product.id === product.id)) {
      const updatedWishlist = [...localWishlist, item];
      localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));
      setWishlist(updatedWishlist);
    }
  };

  // Remove item from wishlist
  const removeFromWishlist = (productId) => {
    const localWishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    const updatedWishlist = localWishlist.filter(
      (item) => item.product.id !== productId
    );
    localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));
    setWishlist(updatedWishlist);
  };

  const syncWishlist = async (userId, accessToken) => {
    const localWishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    try {
      // Use a for...of loop to handle async operations
      for (const item of localWishlist) {
        await addToUserWishlist({
          productId: item.product.id,
          color: item.color,
          userId,
          accessToken,
        });

        // Remove the item from local wishlist after successful sync
        removeFromWishlist(item.product.id, item.color);
      }
    } catch (error) {
      console.error("Failed to sync wishlist item:", error);
    }
  };

  return (
    <WishlistContext.Provider
      value={{ wishlist, addToWishlist, removeFromWishlist, syncWishlist }}
    >
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);